// What the "Lisää maksu" dialog suggests for one participant of an activity.
//
// The amount owed is the member price the participant enrolled at (participant.pricing, CENTS -
// written by the backend at enrolment: a membershipPrices row, or 0 for a free membership entry),
// otherwise the activity's list price (activity.price, EUROS). What they have already paid
// (activity.payments[], CENTS, matched by uid) is subtracted, so a participant who has paid in
// full is not offered the same payment again. The manager can still type any amount.

const toCents = (euros) => (typeof euros === 'number' && isFinite(euros) ? Math.round(euros * 100) : 0)

export const paymentSuggestion = (activity, participant) => {
  const pricing = participant && participant.pricing
  const memberPrice = pricing && typeof pricing.price === 'number' && isFinite(pricing.price)
  const due = memberPrice ? Math.round(pricing.price) : toCents(activity && activity.price)
  const paid = ((activity && activity.payments) || [])
    .filter((p) => participant && p && p.uid === participant.id && typeof p.amount === 'number')
    .reduce((sum, p) => sum + p.amount, 0)
  return {
    // 'entry' = a free entry on a membership, 'member' = a member price, 'list' = the activity price
    source: memberPrice ? (pricing.kind === 'entry' ? 'entry' : 'member') : 'list',
    due,
    paid,
    outstanding: Math.max(0, due - paid),
  }
}

export const centsToInput = (cents) => (cents > 0 ? (cents / 100).toFixed(2).replace('.', ',') : '')
